<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <cards-terminal />
      </v-col>
    </v-row>
  </v-container>
</template>


<script>

import CardsTerminal from '../../components/patio/Terminal/CardsTerminal'

export default {
  data() {
    return {
      page: {
        title: 'Configurações de Terminais',
      },
      breadcrumbs: [
        {
          text: 'Pátios',
          disabled: false,
          to: '/patio/patio',
        },
        {
          text: 'Terminal',
          disabled: false,
        },
      ],
    }
  },
  components: {
    CardsTerminal
  },
  methods: {
    adicionaPatio () {
    }
  }
}
</script>